import { Variant } from "../../types/types";

export const getVariantDimensions = (sizeVariant: Variant) => {
  const variantDimensions = sizeVariant.attributes?.find(
    (attribute) => attribute.displayName === "Dimensions",
  )?.values;

  if (variantDimensions && variantDimensions[0]) {
    if (sizeVariant?.differentiators?.size !== variantDimensions[0]) {
      return `(${variantDimensions[0]})`;
    }
  }

  return;
};
